import React, { Component } from 'react'
import { Nav, Navbar, NavbarToggler, NavbarBrand, Collapse, NavItem} from 'reactstrap'
import { NavLink } from 'react-router-dom'
import './headerComponent.css'

class Header extends Component{
    constructor(props){
        super(props);
        this.state = {
            isNavOpen: false
        }
        this.toggleNav = this.toggleNav.bind(this)
    }
    toggleNav() {
        this.setState({
          isNavOpen: !this.state.isNavOpen
        });
    }
    render(){
        return(
            <React.Fragment>
                <div>
                <Navbar dark expand="md">
                    <div className="container">
                        <NavbarToggler onClick={this.toggleNav} />
                        <NavbarBrand className="ml-auto" href="/"><img src="assets/logo.jpeg" style={{width: '60px'}} alt="logo"/></NavbarBrand>
                        <Collapse isOpen={this.state.isNavOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <NavLink className="nav-link" to='/home'>
                                        <span className="fa fa-home fa-lg"></span> Home
                                    </NavLink>                                    
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link" to='/about'>
                                        <span className="fa fa-info fa-lg"></span> About Me
                                    </NavLink>                                    
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link" to='/education'>
                                        <span className="fa fa-graduation-cap fa-lg"></span> Academics
                                    </NavLink>                                    
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link" to='/projects'>
                                        <span className="fa fa-tasks fa-lg"></span> Projects
                                    </NavLink>                                    
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>
            </div>
            
            </React.Fragment>
        )
    }
}
export default Header